<template>
  <Layout>
    <PageHeader :items="items" :title="title" />
    <div class="row">
      
      <div class="col-12">
        <div class="card">
          <div class="card-body">
             <div class="row">
              <div class="col-md-4 form-group">
                <label>FROM</label>
                <input
                  v-model="filterreport.date1"
                  type="date"
                  class="form-control m-1"
                />
              </div>
              <div class="col-md-4 form-group">
                <label>TO</label>
                <input
                  v-model="filterreport.date2"
                  type="date"
                  class="form-control m-1"
                />
              </div>
                   <div class="col-md-4 form-group">
                <label>CATEGORY</label>
                <model-list-select
                  @input="filteranalysis()"
                  :list="[]"
                  v-model="filterreport.user"
                  option-value="id"
                  option-text="name"
                  placeholder="select Category"
                >
                </model-list-select>
              </div>
              </div>
              

            <!-- Table -->
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      v-model="perPage"
                      :options="pageOptions"
                      class="form-select form-select-sm"
                      size="sm"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>

              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      class="form-control form-control-sm ms-2"
                      placeholder="Search..."
                      type="search"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
         
              <b-table
                :current-page="currentPage"
                :fields="fields"
                :filter="filter"
                :filter-included-fields="filterOn"
                :items="this.RemovedServices"
                :per-page="perPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                bordered
                class="datatables"
                responsive="sm"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(service_status)="data">
                  {{ data.item.status == 1 ? "Done" : "Pending" }}
                </template>
                <template #cell(service_price)="data">
                  {{ data.item.service.price }}
                </template>
              </b-table>
              <h3 v-if="!this.RemovedServices" class="text-primary text-center">
                <b-spinner class="m-0" role="status" variant="primary"></b-spinner>
                Please wait...
              </h3>
              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { ModelListSelect } from "vue-search-select";

import { mapGetters, mapActions } from "vuex";

export default {
  page: {
    title: "Removed Services",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },

  components: {
    Layout,
    PageHeader,
      ModelListSelect,
  },

  data() {
    return {
      filterreport:{
        date1:'',
        date2:'',
        user:'',

      },
      title: "Services Removed From Clients",
      items: [
        {
          text: "Removed Services",
          href: "#",
        },
        {
          text: "Clients",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 15,
      pageOptions: [15, 25, 50, 100, 250, 500, 1000],
      filter: null,
      filterOn: [],
      sortBy: "id",
      sortDesc: true,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "patient",
          sortable: true,
          label: "PATIENT NAME",
        },
        {
          key: "branch",
          sortable: true,
          label: "BRANCH",
        },
        {
          key: "servicename",
          sortable: true,
          label: "SERVICE NAME",
        },
        {
          key: "service_price",
          sortable: true,
          label: "SERVICE PRICE",
        },
        {
          key: "service_status",
          sortable: true,
          label: "STATUS",
        },
        {
          key: "user",
          sortable: true,
          label: "REMOVED BY",
        },
        {
          key: "reason",
          sortable: true,
          label: "REASON",
        },
        {
          key: "dateCreated",
          sortable: true,
          label: "REMOVED ON",
        },
      ],
    };
  },

  computed: {
    ...mapGetters("patients", ["RemovedServices"]),

    rows() {
      return this.RemovedServices ? this.RemovedServices.length : 1;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.RemovedServices ? this.RemovedServices.length : 1;
  },
  methods: {
    ...mapActions({
      FetchRemoved: "patients/fetchRemovedServices",
    }),

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    // COMMA SEPERTOR FUNCTION
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    // END COMMA SEPERATOR
  },

  created() {
    this.FetchRemoved();
  },
};
</script>

<style lang="css" scoped></style>
